// extracted by mini-css-extract-plugin
export default {"root__btn":"style-module__root__btn___dlucD","root__btn_active":"style-module__root__btn_active___tO7sZ","root__block":"style-module__root__block___aPNli","root__title":"style-module__root__title___IUPgv","root__info":"style-module__root__info___uz8Th","root__info_bold":"style-module__root__info_bold___fZtx_"};
    if(module.hot) {
      // 1744730406801
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  